// extracted by mini-css-extract-plugin
export default {"main":"MatchSection_main__Ar5DS","heading":"MatchSection_heading__08LHO","grid":"MatchSection_grid__nY1Bp","box":"MatchSection_box__iLVgr"};